import React from 'react';
import { Div } from '@kizi/core-components';
import { SkeletonBlock, SkeletonWrapper } from './index';

const ProductSkeletonCardMobile = () => {
  return (
    <SkeletonWrapper isMobile direction="column">
      <Div
        display="flex"
        width="100%"
        justifyContent="space-between"
        marginBottom={35}
      >
        <Div display="flex" flexDirection="column" alignItems="start">
          <SkeletonBlock width={105} height={30} marginBottom="5px" />
          <SkeletonBlock width={75} height={15} marginBottom="5px" />
          <SkeletonBlock width={105} height={15} />
        </Div>
        <Div display="flex" flexDirection="column" alignItems="end">
          <SkeletonBlock width={86} height={30} marginBottom="5px" />
          <SkeletonBlock width={53} height={15} marginBottom="5px" />
          <SkeletonBlock width={102} height={30} />
        </Div>
      </Div>
      <Div
        display="flex"
        width="100%"
        justifyContent="space-between"
        marginBottom={35}
      >
        <Div display="flex" flexDirection="column" alignItems="start">
          <SkeletonBlock width={75} height={15} marginBottom="20px" />
          <SkeletonBlock width={43} height={15} marginBottom="5px" />
          <SkeletonBlock width={57} height={15} />
        </Div>
        <Div display="flex" flexDirection="column" alignItems="center" flex={1}>
          <SkeletonBlock width={108} height={53} />
        </Div>
      </Div>
      <Div display="flex" width="100%" justifyContent="space-between">
        <Div display="flex" flexDirection="column" alignItems="start">
          <SkeletonBlock width={57} height={15} />
        </Div>
        <Div display="flex" flexDirection="column" alignItems="center" flex={1}>
          <SkeletonBlock width={164} height={15} />
        </Div>
      </Div>
    </SkeletonWrapper>
  );
};

const ProductSkeletonCardDesktop = () => {
  return (
    <SkeletonWrapper
      isMobile={false}
      marginBottom="42px"
      padding="30px 30px 40px 34px"
    >
      <Div>
        <SkeletonBlock width={105} height={30} marginBottom={15} />
        <SkeletonBlock width={75} height={15} marginBottom={10} />
        <SkeletonBlock width={105} height={15} marginBottom={36} />
        <SkeletonBlock width={75} height={15} />
      </Div>
      <Div>
        <SkeletonBlock width={60} height={15} marginBottom={15} />
        <SkeletonBlock width={180} height={15} marginBottom={15} />
        <SkeletonBlock width={155} height={15} />
      </Div>
      <Div display="flex">
        <SkeletonBlock width={77} height={75} marginRight={21} />
        <SkeletonBlock width={112} height={75} />
      </Div>
      <Div display="flex" flexDirection="column" alignItems="end">
        <SkeletonBlock width={80} height={40} marginBottom={12} />
        <SkeletonBlock width={53} height={15} marginBottom={35} />
        <SkeletonBlock width={102} height={34} />
      </Div>
    </SkeletonWrapper>
  );
};

export const ProductSkeletonCard = () => {
  return (
    <>
      <ProductSkeletonCardMobile />
      <ProductSkeletonCardDesktop />
    </>
  );
};
